import { render, staticRenderFns } from "./ToolboxTalkCreateEditPage.vue?vue&type=template&id=1ff47aeb&"
import script from "./ToolboxTalkCreateEditPage.vue?vue&type=script&lang=js&"
export * from "./ToolboxTalkCreateEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports